import pagination from 'paginationjs';
import { scrollTo } from 'scroll-js';

export const initPagination = (itemsPerPage = 10, itemsCount = 0, paginationGroup, self) => {
	let pages = Math.ceil(Number(itemsCount) / Number(itemsPerPage));
	paginationGroup.pagination({
		dataSource: (done) => {
			let res = [];
			for(let i = 1; i <= pages; i++) {
				res.push(i);
			}
			done(res);
		},
		pageSize: 1,
		pageNumber: (self.params.pageNumber && self.params.pageNumber <= pages) ? self.params.pageNumber : 1,
		prevText: '<i class="icon icon--chevron-md-left"></i>',
		nextText: '<i class="icon icon--chevron-md-right"></i>',
		hideWhenLessThanOnePage: true,
		triggerPagingOnInit: false,
		ulClassName: 'pagination',
		callback: (data, pagination) => {
			self.params.pageNumber = pagination.pageNumber;
			self.$element.trigger('pagination.trigger');
		}
	});

	self.$element.on('pagination.scrollToTop', () => {
		scrollTo(document.body, { top: 0, duration: 0 }).then();
	});
};
